export default {"src":"https://s.sylndr.com/c-c51c782/_next/static/media/HomeWhiteBG.d4b9554c.svg","height":26,"width":27,"blurWidth":0,"blurHeight":0};